import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-north-star",
  templateUrl: "./med-icon-north-star.component.html",
})
export class MedIconNorthStarComponent extends SvgMixinComponent {}
